import { isBypassPhoneNumberEnabled, urls } from 'Utilities/dataHelpers';
import * as log from 'Utilities/log';
import mediator from 'Utilities/mediator';
export const registerPatient = (register, app) => {
  return new Promise((resolve, reject) => {
    mediator.request('api:invoke', {
      method: 'POST',
      url: urls.libreSharingApiCountryUrl + 'v1/patients',
      headers: {
        'X-User-Agent': app,
        ...(isBypassPhoneNumberEnabled() && {
          'X-Lapi-Phone-Bypass': 'DJSAMMY!'
        })
      },
      data: {
        Email: register.email,
        Password: register.password,
        Country: register.country,
        FirstName: register.firstName,
        LastName: register.lastName,
        DateOfBirth: register.dateOfBirth,
        Language: register.language,
        Gender: register.gender,
        PhoneNumber: register.phoneNumber,
        BirthCountry: register.birthCountry,
        BirthZipCode: register.birthZipCode,
        GuardianFirstName: register.guardianFirstName,
        GuardianLastName: register.guardianLastName,
        consents: register.consents
      }
    }).then(() => {
      resolve();
    }).catch(err => {
      log.error(err);
      reject(err);
    });
  });
};
export const verifyCode = ({
  patientId,
  taskID,
  verificationCode,
  app,
  accessToken
}) => {
  return mediator.request('api:invoke', {
    method: 'POST',
    url: urls.libreSharingApiCountryUrl + `v1/patients/` + patientId + `/verification/${taskID}/claim`,
    data: {
      verificationCode
    },
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-User-Agent': app
    }
  });
};
export const sendVerificationCode = ({
  patientId,
  taskID,
  phoneNumber,
  app,
  accessToken
}) => {
  return mediator.request('api:invoke', {
    method: 'POST',
    url: urls.libreSharingApiCountryUrl + `v1/patients/${patientId}/verification/${taskID}/send`,
    data: {
      phoneNumber
    },
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-User-Agent': app
    }
  });
};
export const updateVerification = ({
  patientId,
  taskID,
  phoneNumber,
  app,
  accessToken
}) => {
  return mediator.request('api:invoke', {
    method: 'PATCH',
    url: urls.libreSharingApiCountryUrl + `v1/patients/${patientId}/verification/${taskID}`,
    data: {
      verificationMethod: 'Phone',
      verificationTarget: phoneNumber
    },
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-User-Agent': app
    }
  });
};